export const FORM_CLAIM_DETAIL_PERSONAL = () => {
  const span = 24;
  return [
    {
      name: 'fullName',
      label: 'ชื่อ-นามสกุล',
      type: 'TEXT',
      placeholder: '',
      span,
    },
    {
      name: 'telephone',
      label: 'หมายเลขโทรศัพท์',
      type: 'TEXT',
      placeholder: '',
      span,
    },
    {
      name: 'addressFullText',
      label: 'ที่อยู่',
      type: 'TEXT',
      span,
    },
    {
      name: 'zipCode',
      label: 'รหัสไปรษณีย์',
      type: 'TEXT',
      placeholder: '',
      span,
    },
    {
      name: 'provinceName',
      label: 'จังหวัด',
      type: 'TEXT',
      span,
    },
    {
      name: 'districtName',
      label: 'เขต/อำเภอ',
      type: 'TEXT',
      span,
    },
    {
      name: 'subDistrictName',
      label: 'แขวง/ตำบล',
      type: 'TEXT',
      span,
    },
    {
      name: 'other',
      label: 'เพิ่มเติม',
      type: 'TEXT',
      placeholder: '',
      span,
    },
  ];
};

export const FORM_CLAIM_EDIT_DETAIL_PICTURE = () => {
  return [
    {
      name: 'claimImageUrl',
      label: 'รูปภาพสินค้าเคลม',
      type: 'PREVIEW',
      listType: 'picture-card',
      span: 12,
      maxCount: 1,
    },
    {
      name: 'receiptImageUrl',
      label: 'รูปภาพใบเสร็จ',
      type: 'PREVIEW',
      listType: 'picture-card',
      span: 12,
      maxCount: 1,
    },
  ];
};

export const FORM_CLAIM_DETAIL_CLAIM = () => {
  const span = 24;
  return [
    {
      name: 'claimCode',
      label: 'เลขที่การเคลม',
      type: 'TEXT',
      placeholder: '',
      span,
    },
    {
      name: 'claimId',
      label: 'Claim ID',
      type: 'HIDDEN',
      span,
    },
    {
      name: 'warrantyCode',
      label: 'รหัสลงทะเบียนสินค้า',
      type: 'TEXT',
      span,
    },
    {
      name: 'claimDate',
      label: 'วันที่แจ้งเคลม',
      type: 'TEXT',
      span,
    },
    {
      name: 'productName',
      label: 'ชื่อสินค้า',
      type: 'TEXT',
      span,
    },
    {
      name: 'mobileBrandName',
      label: 'ยี่ห้อ',
      type: 'TEXT',
      span,
    },
    {
      name: 'mobileModelName',
      label: 'รุ่น',
      type: 'TEXT',
      span,
    },
    {
      name: 'breakdownName',
      label: 'อาการเสีย',
      type: 'TEXT',
      span,
    },
    {
      name: 'detail1',
      label: 'รายละเอียด',
      type: 'TEXT',
      span,
    },
    {
      name: 'remark',
      label: 'หมายเหตุ',
      type: 'TEXT',
      span,
    },
    {
      name: 'channelClaimName',
      label: 'ช่องทางการเคลม',
      type: 'TEXT',
      span,
    },
    {
      name: 'storeName',
      label: 'ร้านค้า',
      type: 'TEXT',
      span,
    },
    {
      name: 'claimedDays',
      label: 'จำนวนวันที่แจ้งเคลมมาแล้ว',
      type: 'TEXT',
      span,
    },
    {
      name: 'remainingDays',
      label: 'จำนวนวันคงเหลือ',
      type: 'TEXT',
      span,
    },
    {
      name: 'itemCodeCutOff',
      label: 'รหัสสินค้าตัดประกัน',
      type: 'TEXT',
      span,
    },
  ];
};

export const FORM_CHANGE_PRODUCT = ({
  categoryOptions,
  mobileBrandOptions,
  mobileModelOptions,
  productOptions,
  onEnter,
}) => {
  const span = 24;
  return [
    {
      name: 'claimId',
      type: 'HIDDEN',
    },
    {
      name: 'claimCode',
      type: 'HIDDEN',
    },
    {
      name: 'warrantyNumberCode',
      label: 'รหัสรับประกันสินค้า (กรอกรหัสรับประกันแล้วกด Enter)',
      type: 'INPUT',
      rules: {
        required: true,
      },
      onEnter,
      span,
    },
    {
      name: 'categoryId',
      label: 'สี Qr',
      type: 'DROPDOWN',
      rules: {
        required: true,
      },
      properties: {
        options: categoryOptions || [],
      },
      span,
    },
    {
      name: 'mobileBrandId',
      label: 'ชื่อยี่ห้อ',
      type: 'DROPDOWN',
      properties: {
        options: mobileBrandOptions,
      },
      rules: {
        required: true,
      },
      span,
    },
    {
      name: 'mobileModelId',
      label: 'ชื่อรุ่น',
      type: 'DROPDOWN',
      properties: {
        options: mobileModelOptions || [],
      },
      rules: {
        required: true,
      },
      span,
    },
    {
      name: 'mapProductId',
      label: 'ชื่อสินค้า',
      type: 'DROPDOWN',
      properties: {
        options: productOptions || [],
      },
      rules: {
        required: true,
      },
      span,
    },
    {
      name: 'remark',
      label: 'หมายเหตุ (ระบุได้ไม่เกิน 500 ตัวอักษร)',
      type: 'INPUT_AREA',
      rules: {
        maxLength: 500,
      },
      span,
    },
  ];
};

export const FORM_REJECT = () => {
  return [
    {
      name: 'claimId',
      type: 'HIDDEN',
    },
    {
      name: 'rejectReason',
      label: 'ข้อความ (ระบุได้ไม่เกิน 250 ตัวอักษร)',
      type: 'INPUT_AREA',
      placeholder: '',
      span: 24,
      rules: {
        required: true,
        maxLength: 250,
      },
    },
  ];
};

export const FORM_CANCLE = () => {
  return [
    {
      name: 'claimId',
      type: 'HIDDEN',
    },
    {
      name: 'cancelReason',
      label: 'ข้อความ (ระบุได้ไม่เกิน 250 ตัวอักษร)',
      type: 'INPUT_AREA',
      placeholder: '',
      span: 24,
      rules: {
        required: true,
        maxLength: 250,
      },
    },
  ];
};
